import { Component, ElementRef, ViewChild } from '@angular/core';
import html2canvas from 'html2canvas';
import autoTable from 'jspdf-autotable';
import { teluguText } from '../../fonts-pdf/telugu-language-code';
import { kannadaText } from '../../fonts-pdf/kannada-language-code';
import { tamilText } from '../../fonts-pdf/tamil-language-code';
import { hindiText } from '../../fonts-pdf/hindi-language-code';
import jsPDF from 'jspdf';
import exportFromJSON from 'export-from-json';
import { ChartConfiguration, ChartOptions, ChartType } from "chart.js";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { AsyncSubject, debounceTime, Observable, Subject, Subscription } from 'rxjs';
import { NotifierService } from 'angular-notifier';

import { LoginService } from '../../../../components/login/service/login.service';
import * as CryptoJS from 'crypto-js';
import { HttpErrorResponse } from '@angular/common/http';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { EmailauditService } from './service/emailreaudit.service';
import { AppComponent } from '../../../../app.component';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-email-records',
  templateUrl: './email-records.component.html',
  styleUrl: './email-records.component.scss'
})
export class EmailRecordsComponent {
  
  data = [];
  showData = 'emailTable';
  showModal = 'agentResponse';
  records1: any = [];
  total_records!:number;
  tableData: any = [];
  textTableData: any = [];
  textTableRecords: any = [];
  myBlob = new Blob();
  keywordPercent!: number;
  metric_percentage!: number;
  pause_scorePercentage!: number;
  storeId: any;
  fileIndex!: number;
  transcriptModalData: any = [];
  transcriptModalDataTemp_T: any = [];
  transcriptModalDataTemp: any = [];
  dialogueList: any = [];
  keywordList: any = [];
  alertkeywordList: any = [];
  questionsData: any = [];
  englishQuestions: any = [];
  keywordSummary: any = [];
  mostUsedWords: any = [];
  textEntitiesData: any = [];
  transcriptModalData_T: any = [];
  dialogueList_T: any = [];
  keywordList_T: any = [];
  alertkeywordList_T: any = [];
  questionsData_T: any = [];
  englishQuestions_T: any = [];
  keywordSummary_T: any = [];
  mostUsedWords_T: any = [];
  textEntitiesData_T: any = [];
  input_1: any;
  input_2: any;
  spinner: boolean = false;
  bodySpinner: boolean = false;
  eyeShow: boolean = false;
  storeSpeakerName: any = [];
  tempVariable: any;
  display = 'none';
  filteredSpeaker: any = [];
  transcribedLg = ['English'];
  transcribedLgVariable!: string;
  showSelect: boolean = false;
  transcribedLg_T = ['English'];
  transcribedLgVariable_T!: string;
  showSelect_T: boolean = false;
  store_DSName: any = [];
  filtered_DSName: any = [];
  showRow: boolean = false;
  dialogueIndex!: number;
  inputType = 'button';
  inputValue!: string;
  transcriptIndex!: number;
  editedTranscript: any = [];
  searchText: any;
  searchText2: any;
  searchForm!: FormGroup;
  getSearchText: any;
  call_category: any = [];
  QAMetricsData: any={};
  metricsMatches: any = [];
  modulationData: any = [];
  callCategoryIndex!: number;
  showPagination = false;
  page = 1;
  emailPayload: any = {};
  metricsMScore!: number | null;
  metricsMComments = '';
  showManualInput = false;
  getMetricsIndex!: number | null;
  getRecordIndex!: number;
  infoDetails: any = [];
  infoTopicsName!: string;
  infoTopicsId!: string;
  infoForm!: FormGroup;
  getInfoTopics: any = [];
  splitPattern = new RegExp('[,;]');
  disableInput = false;
  infoEditShow = false;
  getInfoFormValue: any = [];
  getInfoTopicId!: string;
  userDetails: any;
  setTopicId!: string;
  getTableIndex!: number;
  sortingShow: boolean = false;
  selectedRow!: number;
  audioFileIndex = -1;
  filereader: any = new FileReader();
  audioSafeUrl!: SafeUrl;
  blobFile!: File;
  showsentiment = '';
  showSentimentWords = '';
  sentimentGraphData: any;
  sentimentData: any = [];
  sentimentPostiveWords: any = [];
  sentimentNegativeWords: any = [];
  sentimentNeutralWords: any = [];
  customerPostiveWords: any = [];
  customerNegativeWords: any = [];
  customerNeutralWords: any = [];
  agentPostiveWords: any = [];
  agentNegativeWords: any = [];
  agentNeutralWords: any = [];
  tableTrVar!: number;
  audioSpinner = false;
  blobUrl: any;
  audio: any;
  storeJsonBlob: any;
  displaySentiment: boolean = false;
  showPlayPause: boolean = false;
  showModalAudioTag: boolean = false;
  customerEmailtData:any;
  @ViewChild('columnSelect') columnSelect!: ElementRef;
  @ViewChild('conditionSelect') conditionSelect!:ElementRef;
  @ViewChild('fileUpload') fileUploadEle!: ElementRef;
  @ViewChild('restrictScore') restrictScore!:ElementRef;
  @ViewChild(DaterangepickerDirective, { static: false })
  pickerDirective!: DaterangepickerDirective;
  dateTime!: Date;
  getDateData: any;
  startDate: any;
  endDate: any;
  getInputSearchValue!: string;
  selectedSearchOption:any ='';
  inputSub!: Subscription;
  bound = 'inbound';
  keywordPhrases: any = [];
  keywordPhrases_T: any = [];
  downloadReportName = 'report';
  getMetricPercentage!: number;
  textEntitiesResult: any = [];
  textEntitiesResult_T: any = [];
  filterCondition:any[]=[];
  addEntity = false;
  getDownload!: string;
  getDownloadIndex!: number;
  downloadBtnSpinner:boolean = false;
  limit = 25;
  transcriptMinimizedBoolean: boolean = false;
  transcriptMinimizedHeader!: string;
  modalScreenSize!: string;
  infoDetailsLanguage!: string;
  usersRole!: string;
  ttfName!: string;
  fontName!: string;
  fontStyle: any;
  fontLanguage: any;
  translateResponseDataTemp: any = [];
  translateResponseData: any = [];
  translateResponseData_original: any = [];
  translateResponseData_originalTemp: any = [];
  modalArray = [
    'dialogue',
    'keyword',
    'alertKeywords',
    'questions',
    'summary',
    'mostUsedWords',
    'transcript',
    'textEntities',
  ];
  sentimentArray = ['overall', 'customer', 'agent'];
  sentimentWordsArray = ['positive', 'neutral', 'negative'];
  myOptions:any = {
    placement: 'top',
    showDelay: 200,
    hideDelay: 0,
    maxWidth: 200,
    zIndex: 100000,
    trigger: 'hover',
    shadow: true,
  };
  private readonly notifier: NotifierService;
  tranlateLanguages = [
    { lang: 'English', value: 'en' },
    { lang: 'Spanish', value: 'es' },
    { lang: 'Japanese', value: 'ja' },
    { lang: 'Vietnamese', value: 'vi' },
    { lang: 'Arabic', value: 'ar' },
    { lang: 'Bengali', value: 'bn' },
    { lang: 'Chinese', value: 'zh' },
    { lang: 'Dutch', value: 'nl' },
    { lang: 'Finnish', value: 'fi' },
    { lang: 'French', value: 'fr' },
    { lang: 'German', value: 'de' },
    { lang: 'Greek', value: 'el' },
    { lang: 'Hindi', value: 'hi' },
    { lang: 'Tamil', value: 'ta' },
    { lang: 'Urdu', value: 'ur' },
    { lang: 'Kannada', value: 'kn' },
    { lang: 'Telugu', value: 'te' },
    { lang: 'Marathi', value: 'mr' },
  ];
  selectedTranslate: any;
  selectedTranslate_1: any;
  getTranslateLanguage = 'en';
  fromLanguage!: string;
  toLanguage!: string;
  translateSpinner: boolean = false;
  displayName!: string;

  lineChartData: any = {
    labels: [],
    datasets: [
      {
        label: 'Sentiment Score',
        data: [],
        fill: false,
        datalabel: true,
        tension: 0.5,
        borderColor: '#36A2EB',
        backgroundColor: '#9BD0F5',
        pointBackgroundColor: (context: any) => {
          var index = context.dataIndex;
          var value = context.dataset.data[index];
          return value < 0 ? 'red' : '#565c78';
        },
      },
    ],
  };
  public lineChartOptions: ChartOptions<'line'> = {
    responsive: true,
    scales: {
      y: {
        suggestedMin: -1.0,
        suggestedMax: 1.0,
      },
    },
  };
  public lineChartLegend = true;
  //
  public tableSearch: string='';
  tableSearchUpdate = new Subject<string>();
  emailDataResponse: any = [];
  emailData: any = [];
  emailId:any;
  metricFullscreen:boolean=false;
  manualScoreData:any=[];
 
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    
    
    uploadWithCredentials: false,
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText',
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [['bold', 'italic'], ['fontSize']],
  };
  
  mailBodyContent:any

  filtersColumn:any=[];

  filterColumnList:any;
  filterConditionList:any;
  selectedCondition:any;
  mailSendForm:FormGroup=new FormGroup({});
  selectedFiles: any[] = [];
  showingRecords:number=0;
  metricsMScore_valid:boolean=false;
  metricsMScore_valid_text:string="";
  dateRange:any;
  submitemail:boolean=false;
  constructor(
    private emailService: EmailauditService,
    private notifierService: NotifierService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private appComponent: AppComponent,
    private sanitizer: DomSanitizer,
    private service:LoginService
  ) {
    this.notifier = notifierService;
   
    this.tableSearchUpdate.pipe(debounceTime(400)).subscribe((value:any) => {
      this.searchTableData(value);
    });
  }

  ngOnInit(): void {
     this.bodySpinner = true;
    this.dateTime = new Date();
      let user = localStorage.getItem("user");
          if(user){
              var data = CryptoJS.AES.decrypt(user,this.service.enCryptKey).toString(CryptoJS.enc.Utf8);
              this.userDetails = JSON.parse(data);
              this.usersRole = this.userDetails?.role;
           
          }   
    this.usersRole = this.userDetails[0]?.role;
    this.emailPayload = {
      'page':this.page,
      'per_page':this.limit,
      'filters': [{"property":"status","operator":"eq","value":"Completed"}]
    }
   // this.loadPdfRecords();
//this.openDoc(this.showData);
    this.infoForm = this.fb.group({
      display_file_name: [null, Validators.required],
      agent_name: [null, Validators.required],
      topic: [null],
      own_key_words: [null],
      alert_keywords: [null],
      sensitive_words: [null],
      hide_keywords: [null],
      delete_words: [null],
      conversation: [null],
      language: [null],
    });
    this.transcribedLgVariable = this.transcribedLg[0];
    this.transcribedLgVariable_T = this.transcribedLg_T[0];


   this.filterColumnList = [
       
        {
          'id':1,
          'displayName':'Agent Name',
          'value':'agent_name',
          'active':true,
          'condition':[1,2,3]
         },
         {
          'id':2,
          'displayName':'Case ID',
          'value':'case_id',
          'active':false,
          'condition':[1,2,3]
         },
         {
          'id':3,
          'displayName':'Email Date',
          'value':'email_date',
          'active':true,
          'condition':[4,5,6]
         },
         {
          'id':4,
          'displayName':'Subject',
          'value':'subject',
          'active':true,
          'condition':[1,2,3]
         },
         {
          'id':5,
          'displayName':'Status',
          'value':'status',
          'active':false,
          'condition':[7,8,9,10]
         },
         {
          'id':6,
          'displayName':'Sentiment',
          'value':'sentiment',
          'active':true,
          'condition':[11,12,13]
         }
    ];

    this.filterConditionList = [
         {
          'id':1,
          "displayName": "StartsWith",
          "value": "startsWith",
          "display":true
         },
         {
          'id':2,
          "displayName": "Contains",
          "value": "contains",
          "display":true
         },
         {
          'id':3,
          "displayName": "Equal",
          "value": "eq",
          "display":true
         },
         {
          'id':4,
          "displayName": "On",
          "value": "on",
          "display":true
         },
         {
          'id':5,
          "displayName": "Before",
          "value": "before",
          "display":true
         },
         {
          'id':6,
          "displayName": "After",
          "value": "after",
          "display":true
         },
         {
          'id':7,
          "displayName": "Queue",
          "value": "Queue",
          "display":true
         },
         {
          'id':8,
          "displayName": "Processing",
          "value": "Processing",
          "display":true
         },
         {
          'id':9,
          "displayName": "Completed",
          "value": "Completed",
          "display":true
         },
         {
          'id':10,
          "displayName": "Failed",
          "value": "Failed",
          "display":true
         },
         {
          'id':11,
          "displayName": "Positive",
          "value": "Positive",
          "display":true
         },
         {
          'id':12,
          "displayName": "Neutral",
          "value": "Neutral",
          "display":true
         },
         {
          'id':13,
          "displayName": "Negative",
          "value": "Negative",
          "display":true
         }
    ];

   this.filtersColumn = this.filterColumnList.filter((items:any)=>items.active==true);
    this.mailSendForm = this.fb.group({
         email_id:[''],
         from:[''],
         to:['',[Validators.required]],
         subject:['',[Validators.required]],
         body:['',[Validators.required]],
    });

    this.QAMetricsData['audit_details']=[];
  }

  ngAfterViewInit(){
   // this.columnSelect.nativeElement.value=this.filtersColumn[0]['value'];
    this.selectTableData('');
  }

  loadPdfRecords() {
    this.bodySpinner = true;
  
  }

  tableSearchQuery(event:any){
    
   this.tableSearchUpdate.next(event.target.value);
  }

  // email records section
  getEmailDataFun() {
    this.bodySpinner = true;

    if(this.selectedSearchOption=='status' || this.selectedSearchOption=='sentiment'){
      this.emailPayload = {
        page: this.page,
        limit: this.limit,
        'filters': [{ 
          "property":this.selectedSearchOption,
          "operator":"eq",
          "value":this.selectedCondition
        }]
       }
    }
    this.emailPayload['page'] = this.page;
    this.emailService.getEmailData(this.emailPayload).subscribe({
      next: (response:any) => {
        this.emailDataResponse = response;
        this.emailData = this.emailDataResponse['emails'];
        this.total_records = this.emailDataResponse['total'];
       // this.emailData.reverse();
        this.bodySpinner = false;
        if(this.emailData.length==this.limit){
          this.showingRecords = this.limit * this.page;
        }else{
          this.showingRecords = this.limit * (this.page - 1) + this.emailData.length;
        }
      },
      error: (errors:HttpErrorResponse) => {
        console.log('email error', errors);
        this.bodySpinner = false;
      },
    });
  }
  openDoc(data: string) {
    this.showData = data;
    this.tableSearch = '';
    if (this.showData === 'pdf') {
      this.emailPayload = {
        page: this.page,
        limit: this.limit,
        sort: [{ property: 'created_date', dir: 'DESC' }],
        search: '',
      };
      this.loadPdfRecords();
    }
    
    if (this.showData === 'emailTable') {
      this.getEmailDataFun();
    }
  }

  pageChanged(event: any) {
    this.page = event;
    this.emailPayload['per_page']=this.limit;
   
    if (this.showData === 'pdf') {
      this.loadPdfRecords();
    }
    
    if (this.showData === 'text') {
      this.getEmailDataFun();
    }

    if (this.showData === 'emailTable') {
      this.getEmailDataFun();
    }
  }

  tableBack(index: number) {
    this.tableTrVar = index;
  }

  CallCategoryIndex(index: number) {
    if (this.showData === 'pdf') {
      this.callCategoryIndex = index;
      this.call_category = this.tableData[index].call_category;
      this.modulationData = this.tableData[index].modulation_matches;
      this.tableData[index].read = 'Y';
    }
    if (this.showData === 'text') {
      this.callCategoryIndex = index;
      this.call_category = this.textTableData[index].call_category;
      this.modulationData = this.textTableData[index].modulation_matches;
      this.textTableData[index].read = 'Y';
    }
     this.callCategoryIndex = index;
     this.call_category = this.emailData[index].categories;
  }

  clearCallCategory(){
    this.call_category = [];
  }

  sortFun() {
    if (this.showData === 'pdf') {
      if (this.audioFileIndex === -1) {
        if (!this.sortingShow) {
          // ascending order old to new
          const sortedAsc = this.tableData.sort(
            (objA: any, objB: any) =>
              new Date(objA.updated_date).getTime() -
              new Date(objB.updated_date).getTime()
          );
          this.sortingShow = !this.sortingShow;
        } else if (this.sortingShow) {
          // descending order new to old
          const sortedDesc = this.tableData.sort(
            (objA: any, objB: any) =>
              new Date(objB.updated_date).getTime() -
              new Date(objA.updated_date).getTime()
          );
          this.sortingShow = !this.sortingShow;
        }
      }
    }

    if (this.showData === 'text') {
      if (this.audioFileIndex === -1) {
        if (!this.sortingShow) {
          // ascending order old to new
          const sortedAsc = this.textTableData.sort(
            (objA: any, objB: any) =>
              new Date(objA.updated_date).getTime() -
              new Date(objB.updated_date).getTime()
          );
          this.sortingShow = !this.sortingShow;
        } else if (this.sortingShow) {
          // descending order new to old
          const sortedDesc = this.textTableData.sort(
            (objA: any, objB: any) =>
              new Date(objB.updated_date).getTime() -
              new Date(objA.updated_date).getTime()
          );
          this.sortingShow = !this.sortingShow;
        }
      }
    }
    if (this.showData === 'emailTable') {
      if (this.audioFileIndex === -1) {
        if (!this.sortingShow) {
          // ascending order old to new
          const sortedAsc = this.emailData.sort(
            (objA: any, objB: any) =>
              new Date(objA.created_date).getTime() -
              new Date(objB.created_date).getTime()
          );
          this.sortingShow = !this.sortingShow;
        } else if (this.sortingShow) {
          // descending order new to old
          const sortedDesc = this.emailData.sort(
            (objA: any, objB: any) =>
              new Date(objB.created_date).getTime() -
              new Date(objA.created_date).getTime()
          );
          this.sortingShow = !this.sortingShow;
        }
      }
    }
  }

  getSentimentFun(index: number) {
    if (this.showData === 'pdf') {
      const ind = index;
      this.tableData[index].read = 'Y';
      this.sentimentData = this.tableData[index];
      this.sentimentPostiveWords = this.tableData[index]?.positive_words[0];
      this.sentimentNeutralWords = this.tableData[index]?.neutral_words[0];
      this.sentimentNegativeWords = this.tableData[index]?.negative_words[0];
      this.customerPostiveWords =
        this.tableData[index]?.customer_positive_words;
      this.customerNeutralWords = this.tableData[index]?.customer_neutral_words;
      this.customerNegativeWords =
        this.tableData[index]?.customer_negative_words;
      this.agentPostiveWords = this.tableData[index]?.agent_positive_words;
      this.agentNeutralWords = this.tableData[index]?.agent_neutral_words;
      this.agentNegativeWords = this.tableData[index]?.agent_negative_words;
      this.sentimentGraphData = this.tableData[index]?.sentiment_graph[0];
    }
    if (this.showData === 'text') {
      const ind = index;
      this.textTableData[index].read = 'Y';
      this.sentimentData = this.textTableData[index];
      this.sentimentPostiveWords = this.textTableData[index]?.positive_words[0];
      this.sentimentNeutralWords = this.textTableData[index]?.neutral_words[0];
      this.sentimentNegativeWords =
        this.textTableData[index]?.negative_words[0];
      this.customerPostiveWords =
        this.textTableData[index]?.customer_positive_words;
      this.customerNeutralWords =
        this.textTableData[index]?.customer_neutral_words;
      this.customerNegativeWords =
        this.textTableData[index]?.customer_negative_words;
      this.agentPostiveWords = this.textTableData[index]?.agent_positive_words;
      this.agentNeutralWords = this.textTableData[index]?.agent_neutral_words;
      this.agentNegativeWords = this.textTableData[index]?.agent_negative_words;
      this.sentimentGraphData = this.textTableData[index]?.sentiment_graph[0];
    }
    if (this.showData === 'emailTable') {
      const ind = index;
     // this.emailData[index].read = 'Y';
      this.showModal =='customerMail';
      this.sentimentData = this.emailData[index];
      let ai_response = JSON.parse(this.sentimentData['ai_response']);
      this.sentimentData['ai_response'] = ai_response['reply_body'];
      this.metricFullscreen = true;
     
      // this.sentimentPostiveWords = this.emailData[index]?.positive_words;
      // this.sentimentNeutralWords = this.emailData[index]?.neutral_words;
      // this.sentimentNegativeWords = this.emailData[index]?.negative_words;
      // this.customerPostiveWords =
      //   this.emailData[index]?.customer_positive_words;
      // this.customerNeutralWords = this.emailData[index]?.customer_neutral_words;
      // this.customerNegativeWords =
      //   this.emailData[index]?.customer_negative_words;
      // this.agentPostiveWords = this.emailData[index]?.agent_positive_words;
      // this.agentNeutralWords = this.emailData[index]?.agent_neutral_words;
      // this.agentNegativeWords = this.emailData[index]?.agent_negative_words;
      // this.sentimentGraphData = this.emailData[index]?.sentiment_graph;
    }
  }

  sentimentHeading(value: string) {
    this.sentimentArray.forEach((item) => {
      if (value === item) {
        this.showsentiment = value;
      }
    });
    if (this.showsentiment === 'overall') {
      this.lineChartData.datasets[0].data = this.sentimentGraphData;
      this.lineChartData.labels = this.sentimentGraphData;
    }
  }

  sentimentWordsHeading(value: string) {
    this.sentimentWordsArray.forEach((item) => {
      if (value === item) {
        this.showSentimentWords = value;
      }
    });
  }

  getTranscriptFun(index: number, name: string) {
    this.searchText = '';
    if (this.transcribedLg_T.length > 1) {
      this.transcribedLg_T.shift();
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
    }
   
   
    if (this.showData === 'emailTable') {
      this.fileIndex = index;
      this.storeId = this.emailData[this.fileIndex]?.file_id.$oid;
      if (name == 'transcriptModal') {
        this.spinner = true;
        this.emailService.getTranscriptData(this.storeId).subscribe(
          (sub: any) => {
            this.transcriptModalDataTemp_T = sub;
            this.questionsData_T = this.transcriptModalDataTemp_T.result;
            this.dialogueList_T = this.questionsData_T?.text?.split(/[.?]/);
            this.mostUsedWords_T = this.questionsData_T?.most_used_words;
            this.keywordPhrases_T = this.questionsData_T?.own_keywords_result;
            this.alertkeywordList_T =
              this.questionsData_T?.alert_keywords_result;
            this.keywordSummary_T = this.questionsData_T?.keywords;
            this.englishQuestions_T = this.questionsData_T?.questions;
            this.emailData[index].read = 'Y';
            this.keywordPhrases_T?.sort((a: any, b: any) => {
              return b.count - a.count;
            });
            this.alertkeywordList_T?.sort((a: any, b: any) => {
              return b.count - a.count;
            });
            this.globalSearchHighlighterFun();
            this.spinner = false;
          },
          (error: any) => {
            console.log('transcript keywords error: ', error);
            this.spinner = false;
          }
        );
      }
      if (name == 'otherModal') {
        this.spinner = true;
        this.emailService.getTranscriptData(this.storeId).subscribe(
          (sub: any) => {
            this.transcriptModalDataTemp = sub;
            this.questionsData = this.transcriptModalDataTemp.result;
            this.dialogueList = this.questionsData?.text?.split(/[.?]/);
            this.globalSearchHighlighterFun();
            this.spinner = false;
          },
          (error: any) => {
            console.log('transcript keywords error: ', error);
            this.spinner = false;
          }
        );
      }
      if (name == 'questions' || name == 'transcript') {
        this.globalSearchHighlighterFun();
      }
    }
  }

  transcriptSelectedLgFun(language: string) {
    if (language === 'es' || language?.slice(0, 2) === 'es') {
      if (this.transcribedLg.length < 2) {
        this.transcribedLg.unshift('Spanish');
      }
      this.transcribedLgVariable = this.transcribedLg[0];
      this.showSelect_T = true;
    }
    if (language === 'hi' || language?.slice(0, 2) === 'hi') {
      if (this.transcribedLg.length < 2) {
        this.transcribedLg.unshift('Hindi');
      }
      this.showSelect = true;
      this.transcribedLgVariable = this.transcribedLg[0];
    }
    if (language === 'en' || language?.slice(0, 2) === 'en') {
      this.showSelect = false;
    }
    if (language === 'kn' || language?.slice(0, 2) === 'kn') {
      if (this.transcribedLg.length < 2) {
        this.transcribedLg.unshift('Kannada');
      }
      this.showSelect = true;
      this.transcribedLgVariable = this.transcribedLg[0];
    }
    if (language === 'ta' || language.slice(0, 2) === 'ta') {
      if (this.transcribedLg.length < 2) {
        this.transcribedLg.unshift('Tamil');
      }
      this.showSelect = true;
      this.transcribedLgVariable = this.transcribedLg[0];
    }
    if (language === 'mr' || language.slice(0, 2) === 'mr') {
      if (this.transcribedLg.length < 2) {
        this.transcribedLg.unshift('Marathi');
      }
      this.showSelect = true;
      this.transcribedLgVariable = this.transcribedLg[0];
    }
    if (language === 'te' || language.slice(0, 2) === 'te') {
      if (this.transcribedLg.length < 2) {
        this.transcribedLg.unshift('Telugu');
      }
      this.showSelect = true;
      this.transcribedLgVariable = this.transcribedLg[0];
    }
    if (language === 'gu' || language.slice(0, 2) === 'gu') {
      if (this.transcribedLg.length < 2) {
        this.transcribedLg.unshift('Gujarati');
      }
      this.showSelect = true;
      this.transcribedLgVariable = this.transcribedLg[0];
    }
    if (language === 'bn' || language.slice(0, 2) === 'bn') {
      if (this.transcribedLg.length < 2) {
        this.transcribedLg.unshift('Bengali');
      }
      this.showSelect = true;
      this.transcribedLgVariable = this.transcribedLg[0];
    }
  }

  transcriptSelectedLgFunTranscriptModal(language: string) {
    if (language === 'es' || language?.slice(0, 2) === 'es') {
      if (this.transcribedLg_T.length < 2) {
        this.transcribedLg_T.unshift('Spanish');
      }
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
      this.showSelect_T = true;
    }
    if (language === 'hi' || language?.slice(0, 2) === 'hi') {
      if (this.transcribedLg_T.length < 2) {
        this.transcribedLg_T.unshift('Hindi');
      }
      this.showSelect_T = true;
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
    }
    if (language === 'en' || language?.slice(0, 2) === 'en') {
      this.showSelect_T = false;
    }
    if (language === 'kn' || language?.slice(0, 2) === 'kn') {
      if (this.transcribedLg_T.length < 2) {
        this.transcribedLg_T.unshift('Kannada');
      }
      this.showSelect_T = true;
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
    }
    if (language === 'ta' || language.slice(0, 2) === 'ta') {
      if (this.transcribedLg_T.length < 2) {
        this.transcribedLg_T.unshift('Tamil');
      }
      this.showSelect_T = true;
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
    }
    if (language === 'mr' || language.slice(0, 2) === 'mr') {
      if (this.transcribedLg_T.length < 2) {
        this.transcribedLg_T.unshift('Marathi');
      }
      this.showSelect_T = true;
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
    }
    if (language === 'te' || language.slice(0, 2) === 'te') {
      if (this.transcribedLg_T.length < 2) {
        this.transcribedLg_T.unshift('Telugu');
      }
      this.showSelect_T = true;
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
    }
    if (language === 'gu' || language.slice(0, 2) === 'gu') {
      if (this.transcribedLg_T.length < 2) {
        this.transcribedLg_T.unshift('Gujarati');
      }
      this.showSelect_T = true;
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
    }
    if (language === 'bn' || language.slice(0, 2) === 'bn') {
      if (this.transcribedLg_T.length < 2) {
        this.transcribedLg_T.unshift('Bengali');
      }
      this.showSelect_T = true;
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
    }
  }

  changeTranscriptLgFun() {
    this.searchText = '';
    if (this.transcribedLgVariable_T === 'English') {
      this.dialogueList_T = this.transcriptModalData_T[0]?.text.split(/[.?]/);
      this.englishQuestions_T = this.questionsData_T[0]?.questions;
      this.keywordSummary_T = this.questionsData_T[0]?.keywords;
      this.mostUsedWords_T = this.transcriptModalData_T[0]?.most_used_words;
    } else {
      this.dialogueList_T =
        this.transcriptModalData_T[0]?.spanish_text.split(/[.?]/);
      this.englishQuestions_T = this.questionsData_T[0]?.spanish_questions;
      this.keywordSummary_T = this.questionsData_T[0]?.spanish_keywords;
      this.mostUsedWords_T =
        this.transcriptModalData_T[0]?.spanish_most_used_words;
    }
    this.globalSearchHighlighterFun();
  }

  DownloadEntityData() {
    if (this.showData === 'pdf') {
      exportFromJSON({
        data: this.textEntitiesResult_T,
        fileName: this.tableData[this.fileIndex].display_file_name,
        exportType: 'json',
      });
    }
    if (this.showData === 'text') {
      exportFromJSON({
        data: this.textEntitiesResult_T,
        fileName: this.textTableData[this.fileIndex].display_file_name,
        exportType: 'json',
      });
    }
  }

  downloadJson() {
    this.storeJsonBlob = new Blob(
      [JSON.stringify(this.transcriptModalData_T[0].text_entities)],
      { type: 'application/json' }
    );
    this.blobUrl = URL.createObjectURL(this.storeJsonBlob);
    this.audioSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.blobUrl
    );
  }

  clearKeywordDetailsTranscriptModal() {
    setTimeout(() => {
      this.modalScreenSize = '';
      this.transcriptModalData_T = [];
      this.transcriptModalDataTemp_T = [];
      this.dialogueList_T = [];
      this.keywordList_T = [];
      this.alertkeywordList_T = [];
      this.keywordSummary_T = [];
      this.mostUsedWords_T = [];
      this.questionsData_T = [];
      this.englishQuestions_T = [];
      this.keywordPhrases_T = [];
      if (this.transcribedLg_T.length > 1) {
        this.transcribedLg_T.shift();
      }
      this.transcribedLgVariable_T = this.transcribedLg_T[0];
      this.showSelect_T = false;
    }, 400);
    this.searchText = '';
  }

  clearKeywordDetails() {
    setTimeout(() => {
      this.transcriptModalData = [];
      this.transcriptModalDataTemp = [];
      this.dialogueList = [];
      this.keywordList = [];
      this.infoDetails = [];
      this.alertkeywordList = [];
      this.keywordSummary = [];
      this.mostUsedWords = [];
      this.questionsData = [];
      this.englishQuestions = [];
      this.keywordPhrases = [];
      if (this.transcribedLg.length > 1) {
        this.transcribedLg.shift();
      }
      this.transcribedLgVariable = this.transcribedLg[0];
      this.showSelect = false;
    }, 400);
    this.searchText = '';
    this.submitemail=false;
  }

  clearRecordData() {
    this.infoEditShow = false;
    this.infoDetails = [];
    this.infoTopicsName = '';
    this.infoForm.reset();
  }

  getQAMetricsData(index: number) {
   this.emailId = this.emailData[index]['id'];
   this.metricFullscreen = true;
   this.spinner = true;
  this.manualScoreData = [];
  this.QAMetricsData={};
  this.getMetricsIndex = null;
  this.metricsMatches = [];
    this.emailService.getQAScoreEmail(this.emailId).subscribe((res:any)=>{
            this.QAMetricsData= res['email'];
          
            this.metricsMatches = this.QAMetricsData?.audit_details;
            this.spinner = false;
            if(this.metricsMatches.length > 0){
              this.metricsMatches.forEach((items:any)=>{

                 let data =  {
                    //"email_id":this.emailId,
                    "email_audit_id":items['id'],
                    "manual_score":items['manual_score'],
                    "manual_score_comments":(items?.manual_score_comments==undefined) ? "" :items?.manual_score_comments
                  };
                  this.manualScoreData.push(data);
              });
             
            }
            
    },(error:any)=>{
      this.spinner = false;
    });
    // if (this.showData === 'pdf') {
    //   this.QAMetricsData = this.tableData[index].metrics_matches;
    //   this.metricsMatches = this.QAMetricsData;
    //   this.getMetricPercentage = this.tableData[index].metric_percentage;
    // }
    // if (this.showData === 'text') {
    //   this.QAMetricsData = this.textTableData[index].metrics_matches;
    //   this.metricsMatches = this.QAMetricsData;
    //   this.getMetricPercentage = this.textTableData[index].metric_percentage;
    // }
  }

  modalHeading(value: string) {
    
      
        this.showModal = value;
      
    
  }

  getReportData(index: number, value: string) {
    // this.getDownload = value;
    // if (this.transcribedLg.length > 1) {
    //   this.transcribedLg.shift();
    //   this.transcribedLgVariable = this.transcribedLg[0];
    // }
    // if (this.getDownload === 'download') {
    //   this.getDownloadIndex = index;
    // }
    // this.spinner = true;
 
 

    // if (this.showData === 'emailTable') {
    //   this.infoDetails = this.emailData[index];
    //   this.downloadReportName = this.emailData[index]?.display_file_name;
    //   this.fileIndex = index;
    //   this.storeId = this.emailData[this.fileIndex]?.file_id.$oid;
    //   if (value === 'keywordPercentage') {
    //     this.emailService.getTranscriptData(this.storeId).subscribe(
    //       (sub: any) => {
    //         this.questionsData = sub;
    //         this.keywordPhrases = this.questionsData[0]?.own_keywords_result;
    //         this.keywordPhrases.sort((a: any, b: any) => {
    //           return b.count - a.count;
    //         });
    //         this.spinner = false;
    //       },
    //       (error: any) => {
    //         this.spinner = false;
    //         console.log('transcript keywords error: ', error);
    //       }
    //     );
    //   } else {
    //     this.emailService.getTranscriptData(this.storeId).subscribe(
    //       (sub: any) => {
    //         this.transcriptModalDataTemp = sub
    //         this.transcriptModalData = this.transcriptModalDataTemp.result;
    //         console.log("trans", this.transcriptModalData)
    //         this.keywordPhrases = this.transcriptModalData.own_keywords_result;
    //         this.alertkeywordList = this.transcriptModalData.alert_keywords_result;
    //         this.emailData[index].read = 'Y';
    //         const language = this.transcriptModalData[0]?.language;
    //         this.transcriptSelectedLgFun(language);
    //         if (language === 'en') {
    //           this.dialogueList =
    //             this.transcriptModalData[0]?.text.split(/[.?]/);
    //           this.mostUsedWords = this.transcriptModalData[0]?.most_used_words;
    //         } else {
    //           this.dialogueList =
    //             this.transcriptModalData[0]?.spanish_text.split(/[.?]/);
    //           this.mostUsedWords =
    //             this.transcriptModalData[0]?.spanish_most_used_words;
    //         }
    //       },
    //       (error: any) => {
    //         this.spinner = false;
    //         console.log('Transcript got error', error);
    //       }
    //     );

    //     this.emailService.getTranscriptData(this.storeId).subscribe(
    //       (sub: any) => {
    //         this.questionsData = sub;
    //         // this.keywordPhrases = this.questionsData[0]?.own_keywords_result;
    //         // this.alertkeywordList = this.questionsData[0]?.alert_keywords_result;
    //         const language = this.questionsData[0]?.language;
    //         this.transcriptSelectedLgFun(language);
    //         this.keywordPhrases.sort((a: any, b: any) => {
    //           return b.count - a.count;
    //         });
    //         this.alertkeywordList.sort((a: any, b: any) => {
    //           return b.count - a.count;
    //         });
    //         if (
    //           this.questionsData[0]?.language === 'en' ||
    //           this.questionsData[0]?.language === 'English'
    //         ) {
    //           this.englishQuestions = this.questionsData[0]?.questions;
    //           this.keywordSummary = this.questionsData[0]?.keywords;
    //         } else {
    //           this.englishQuestions = this.questionsData[0]?.spanish_questions;
    //           this.keywordSummary = this.questionsData[0]?.spanish_keywords;
    //         }
    //         if (this.getDownload === 'download') {
    //           this.makePDF();
    //         } else {
    //           this.spinner = false;
    //         }
    //       },
    //       (error: any) => {
    //         this.spinner = false;
    //         console.log('transcript keywords error: ', error);
    //       }
    //     );
    //   }
    // }
  }

  changeTranscriptLgReport() {
    if (this.transcribedLgVariable === 'English') {
      this.dialogueList = this.transcriptModalData[0]?.text.split(/[.?]/);
      this.englishQuestions = this.questionsData[0]?.questions;
      this.keywordSummary = this.questionsData[0]?.keywords;
      this.mostUsedWords = this.transcriptModalData[0]?.most_used_words;
    } else {
      this.dialogueList =
        this.transcriptModalData[0]?.spanish_text.split(/[.?]/);
      this.englishQuestions = this.questionsData[0]?.spanish_questions;
      this.keywordSummary = this.questionsData[0]?.spanish_keywords;
      this.mostUsedWords = this.transcriptModalData[0]?.spanish_most_used_words;
    }
  }

  getInfoData(index: number) {
    this.spinner = true;
   

   
  }

  getIndex(index: number) {
    this.getRecordIndex = index;
  }

  deleteSelectRecord(index: number) {
    this.bodySpinner = true;
   
   if (this.showData === 'emailTable') {
      this.storeId = this.emailData[index]?.id;
      this.emailService.deleteEmailData(this.storeId).subscribe(
        (response:any) => {
          this.emailData.splice(index, 1);
          this.notifier.notify('default', 'Deleted Successfully!');
          this.bodySpinner = false;
        },
        (errors:HttpErrorResponse) => {
          this.bodySpinner = false;
          console.log(errors);
        }
      );
    }
  }
  updateInfoDetails() {
    this.getInfoFormValue = this.infoForm.value;
  
   
  }

  editInfoDetails() {
    const formObject = {
      display_file_name: this.infoDetails?.display_file_name,
      agent_name: this.infoDetails?.agent_name,
      topic: this.infoTopicsId,
      own_key_words: this.infoDetails?.own_key_words,
      alert_keywords: this.infoDetails?.alert_keywords,
      sensitive_words: this.infoDetails?.sensitive_words,
      hide_keywords: this.infoDetails?.hide_keywords,
      delete_words: this.infoDetails?.delete_words,
      conversation: this.infoDetails?.conversation,
      language: this.infoDetailsLanguage,
    };

    this.infoEditShow = !this.infoEditShow;
    this.infoForm.patchValue(formObject);
  }

  async makePDF() {
   /* this.downloadBtnSpinner = true;
    this.displaySentiment = true;
    let doc = new jsPDF();
    doc.setFontSize(22);
    doc.setTextColor(25, 118, 210);
    doc.text('Recorded Call Analysis Report', 105, 10, { align: 'center' });
    if (
      this.transcribedLgVariable !== 'Hindi' &&
      this.transcribedLgVariable !== 'Tamil' &&
      this.transcribedLgVariable !== 'Kannada' &&
      this.transcribedLgVariable !== 'Telugu'
    ) {
      autoTable(doc, {
        html: '#report-top-details',
        theme: 'grid',
        includeHiddenHtml: true,
        margin: { top: 20 },
        columnStyles: {
          0: { textColor: [0, 0, 0] },
          2: { textColor: [0, 0, 0] },
        },
        headStyles: { fillColor: [25, 118, 210], fontSize: 12 },
        bodyStyles: { fontSize: 12 },
      });

      await html2canvas(document.getElementById('sentimentCard3')!, {
        allowTaint: true,
        useCORS: true,
        imageTimeout: 1000,
        scale: 2,
        onclone: (cloneDoc) => {
          cloneDoc.getElementById('sentimentCard3')!.style.display = 'block';
        },
      }).then((canvas) => {
        var imgData = canvas.toDataURL('image/png');
        doc.addImage(imgData, 'PNG', 40, 52, 130, 50);
      });

      autoTable(doc, {
        html: '#transcriptReport',
        theme: 'grid',
        includeHiddenHtml: true,
        startY: 110,
        headStyles: { fillColor: [25, 118, 210], fontSize: 12 },
        bodyStyles: { fontSize: 12 },
      });

      autoTable(doc, {
        html: '#question-answer-report',
        theme: 'grid',
        pageBreak: 'avoid',
        includeHiddenHtml: true,
        headStyles: { fillColor: [25, 118, 210], fontSize: 12 },
        bodyStyles: { fontSize: 12 },
      });

      autoTable(doc, {
        columns: [{ header: 'Keyword/Phrases' }],
        html: '#keyword-phrases-table-report',
        theme: 'grid',
        includeHiddenHtml: true,
        headStyles: { fillColor: [25, 118, 210], fontSize: 12 },
        bodyStyles: { fontSize: 12 },
      });

      autoTable(doc, {
        columns: [{ header: 'Most Used Words' }],
        html: '#most-used-words-table-report',
        theme: 'grid',
        includeHiddenHtml: true,
        headStyles: { fillColor: [25, 118, 210], fontSize: 12 },
        bodyStyles: { fontSize: 12 },
      });
      doc.save(this.downloadReportName + '' + '.pdf');
      this.downloadBtnSpinner = false;
      this.spinner = false;
      this.getDownloadIndex = -1;
    } else {
      if (this.transcribedLgVariable === 'Hindi') {
        this.fontLanguage = hindiText;
        this.ttfName = 'NotoSansDevanagari-VariableFont_wdth,wght-normal.ttf';
        this.fontName = 'NotoSansDevanagari-VariableFont_wdth,wght';
        this.fontStyle = 'normal';
      }
      if (this.transcribedLgVariable === 'Tamil') {
        this.fontLanguage = tamilText;
        this.ttfName = 'New_Kannan_Text-normal.ttf';
        this.fontName = 'New_Kannan_Text';
        this.fontStyle = 'normal';
      }
      if (this.transcribedLgVariable === 'Kannada') {
        this.fontLanguage = kannadaText;
        this.ttfName = 'BalooTamma2-Regular-normal.ttf';
        this.fontName = 'BalooTamma2-Regular';
        this.fontStyle = 'normal';
      }
      if (this.transcribedLgVariable === 'Telugu') {
        this.fontLanguage = teluguText;
        this.ttfName = 'HindGuntur-Regular-normal.ttf';
        this.fontName = 'HindGuntur-Regular';
        this.fontStyle = 'normal';
      }
      doc.addFileToVFS(this.ttfName, this.fontLanguage);
      doc.addFont(this.ttfName, this.fontName, this.fontStyle);
      doc.setFont(this.fontName);
      autoTable(doc, {
        styles: {
          font: this.fontName,
          fontStyle: this.fontStyle,
        },
        html: '#report-top-details',
        theme: 'grid',
        includeHiddenHtml: true,
        margin: { top: 20 },
        headStyles: { fillColor: [25, 118, 210], fontSize: 12 },
        bodyStyles: { fontSize: 12 },
      });

      await html2canvas(document.getElementById('sentimentCard3')!, {
        allowTaint: true,
        useCORS: true,
        imageTimeout: 1000,
        scale: 2,
        onclone: (cloneDoc) => {
          cloneDoc.getElementById('sentimentCard3')!.style.display = 'block';
        },
      }).then((canvas) => {
        var imgData = canvas.toDataURL('image/png');
        doc.addImage(imgData, 'PNG', 40, 52, 130, 50);
      });

      autoTable(doc, {
        styles: {
          font: this.fontName,
          fontStyle: this.fontStyle,
        },
        html: '#transcriptReport',
        theme: 'grid',
        includeHiddenHtml: true,
        startY: 110,
        headStyles: { fillColor: [25, 118, 210], fontSize: 12 },
        bodyStyles: { fontSize: 12 },
      });

      autoTable(doc, {
        styles: {
          font: this.fontName,
          fontStyle: this.fontStyle,
        },
        html: '#question-answer-report',
        theme: 'grid',
        pageBreak: 'avoid',
        includeHiddenHtml: true,
        headStyles: { fillColor: [25, 118, 210], fontSize: 12 },
        bodyStyles: { fontSize: 12 },
      });

      autoTable(doc, {
        styles: {
          font: this.fontName,
          fontStyle: this.fontStyle,
        },
        columns: [{ header: 'Keyword/Phrases' }],
        html: '#keyword-phrases-table-report',
        theme: 'grid',
        includeHiddenHtml: true,
        headStyles: { fillColor: [25, 118, 210], fontSize: 12 },
        bodyStyles: { fontSize: 12 },
      });

      autoTable(doc, {
        styles: {
          font: this.fontName,
          fontStyle: this.fontStyle,
        },
        columns: [{ header: 'Most Used Words' }],
        html: '#most-used-words-table-report',
        theme: 'grid',
        includeHiddenHtml: true,
        headStyles: { fillColor: [25, 118, 210], fontSize: 12 },
        bodyStyles: { fontSize: 12 },
      });
      doc.save(this.downloadReportName + '' + '.pdf');
      this.downloadBtnSpinner = false;
      this.spinner = false;
      this.getDownloadIndex = -1;
    } */
  }

  clearModalData() {
    setTimeout(() => {
      this.metricsMatches = [];
      this.QAMetricsData = [];
    }, 400);
    this.showManualInput = false;
  }

  showManualField(index: any) {
    this.showManualInput = true;
    this.getMetricsIndex = index;
    this.metricsMScore = this.metricsMatches[index]['manual_score'];
    this.metricsMComments = this.metricsMatches[index]['manual_score_comments'];
    // this.metricsMScore =
    //   this.metricsMatches[
    //     this.getMetricsIndex
    //   ].manual_score;
    // this.metricsMComments =
    //   this.QAMetricsData.metricsMatches[
    //     this.getMetricsIndex
    //   ].manual_comments;
  }

  clearSentimentData() {
    setTimeout(() => {
      this.sentimentGraphData = [];
      this.lineChartData.datasets[0].data = [];
      this.sentimentData = [];
      this.sentimentPostiveWords = [];
      this.sentimentNeutralWords = [];
      this.sentimentNegativeWords = [];
      this.customerPostiveWords = [];
      this.customerNeutralWords = [];
      this.customerNegativeWords = [];
      this.agentPostiveWords = [];
      this.agentNeutralWords = [];
      this.agentNegativeWords = [];
      this.lineChartData.labels = [];
      this.showsentiment = '';
      this.showSentimentWords = '';
    }, 400);
  }

  searchTableData(value: string) {
    if (this.showData === 'emailTable') {
      this.getInputSearchValue = value;
      if(this.getInputSearchValue){
        this.emailPayload = {
          page: 1,
          limit: this.limit,
          'filters': [{ 
             "property":this.selectedSearchOption,
             "operator": this.selectedCondition,
             "value":this.getInputSearchValue
           }]
        }
        this.page=1;
      }else if(this.selectedSearchOption=='status' || this.selectedSearchOption=='sentiment'){
        this.emailPayload = {
          page: 1,
          limit: this.limit,
          'filters': [{ 
            "property":this.selectedSearchOption,
            "operator":"eq",
            "value":this.selectedCondition
          }]
         }
         this.page=1;
      }else{
        this.emailPayload = {
          page: 1,
          limit: this.limit,
          'filters': []
        }
        this.page=1;
      }
   
      this.getEmailDataFun();
    }

    if (this.showData === 'text') {
      this.getInputSearchValue = value;
      this.emailPayload = {
        page: 1,
        limit: this.limit,
        sort: [{ property: 'created_date', dir: 'DESC' }],
        
      };
     // this.pageChanged(1);
    }
  }

  hideMinimizedModal(value: string) {
    if (value === 'Transcript') {
      this.transcriptMinimizedBoolean = false;
      this.transcriptMinimizedHeader = '';
    }
  }

  showMinimizedModal(value: string) {
    if (value === 'Transcript') {
      this.transcriptMinimizedBoolean = true;
      this.transcriptMinimizedHeader = value;
    }
  }

  modalFullScreen(value: string) {
    if (value === 'max') {
      this.modalScreenSize = 'modal-fullscreen';
    }
    if (value === 'min') {
      this.modalScreenSize = '';
    }
  }

  deleteEmailTableData() {
    // this.emailService.deleteEmailData()
  }

  getTranslateDataFun_1(index: number) {
    this.spinner = true;
    
    
  }

  translateTextData(formValue: any) {
    if (this.getTranslateLanguage === 'en' && !this.translateResponseDataTemp) {
      this.spinner = true;
    } else {
      this.translateSpinner = true;
    }
    if (formValue === 'en') {
      this.fromLanguage = 'es';
    } else {
      this.fromLanguage = 'en';
    }
    this.toLanguage = formValue;
    const payload = {
      fromlanguage: this.fromLanguage,
      tolanguage: this.toLanguage,
      type: 0,
      text: this.translateResponseData_originalTemp?.rawText,
      fileid: this.storeId,
    };
  
    
  }

  clearTranslateModalData() {
    setTimeout(() => {
      this.translateResponseData_originalTemp = [];
      this.translateResponseData_original = [];
      this.translateResponseData = [];
      this.translateResponseDataTemp = [];
      this.fromLanguage = '';
      this.toLanguage = '';
      this.storeId = '';
      this.selectedTranslate = '';
      this.selectedTranslate_1 = '';
    }, 400);
  }

  globalSearchHighlighterFun() {
    setTimeout(() => {
      if (this.tableSearch || this.searchText2) {
        this.searchText = this.tableSearch;
        if (this.showData === 'emailTable') {
          this.searchText = this.searchText2;
        }
      } else {
        this.searchText = '';
      }
    }, 200);
  }

  clearMetricsModalData(){
    this.manualScoreData = [];
    this.QAMetricsData = [];
    this.metricsMatches=[];
    this.clearModalData();
  }

  updateMetricsManualField(){
  this.spinner = true;
  this.getMetricsIndex = null;
  this.metricsMScore_valid  = false;
    this.metricsMScore_valid_text = "";
   this.emailService.updateManualScore({"email_id":this.emailId,"manual_scores":this.manualScoreData}).subscribe((res:any)=>{
     this.notifier.notify('default','Manual scored updated');
     this.getMetricsIndex = null;
     let index = this.emailData.findIndex((emails:any)=> emails['id']==this.emailId);
         this.getQAMetricsData(index);
         this.getEmailDataFun();
     });
  }

  getEmailBody(index:any){
   
    this.showModal =='customerMail';
    this.metricFullscreen = true;
    this.customerEmailtData=[];
    this.customerEmailtData = this.emailData[index];
    // let ai_response = JSON.parse(this.sentimentData['ai_response']);
    // this.sentimentData['ai_response'] = ai_response;
    // this.mailBodyContent = this.changeNewLine(this.sentimentData['ai_response']['reply_body']);
 
  }


  getEmailReply(index:any){
    this.showModal =='customerMail';
    this.metricFullscreen = true;
    this.sentimentData = this.emailData[index];
    let ai_response = JSON.parse(this.sentimentData['ai_response']);
    this.sentimentData['ai_response'] = ai_response;
    if(this.sentimentData['ai_response']){
      this.mailBodyContent = this.changeNewLine(this.sentimentData['ai_response']['reply_body']);
    } else{
      this.mailBodyContent="";
    }
   // this.mailBodyContent = this.changeNewLine(this.sentimentData['ai_response']['reply_body']);
    this.selectedFiles=[];
    let payload={
      "email_id":this.sentimentData?.id,
      "from":this.sentimentData?.agent_mail_id,
      "to":this.sentimentData?.customer_mail_id,
      "subject":(this.sentimentData?.ai_response==null) ? '' : this.sentimentData?.ai_response?.reply_subject,
      "body":this.mailBodyContent
     }

     this.mailSendForm.patchValue(payload);
  }

  sendMetricIndex(index: number, value: string,event:any) {
 
   if (this.manualScoreData.length > 0) {
      if(value=="score"){
        let score_value = event.target.value;
        var numberValidate_reg:any='/^[0-9]*$/';
        if(this.restrictScore.nativeElement.value=="" || parseInt(this.restrictScore.nativeElement.value) < 0){
          this.manualScoreData[index]["email_audit_id"] =  this.manualScoreData[index]["email_audit_id"];
          this.manualScoreData[index]["manual_score"] = null;
          this.metricsMatches[index]["manual_score"] = "";
        }else if(this.restrictScore.nativeElement.value !="" && parseInt(this.metricsMatches[index]['config_score']) == parseInt(this.restrictScore.nativeElement.value) || parseInt(this.restrictScore.nativeElement.value) == 0){
            this.manualScoreData[index]["email_audit_id"] =  this.manualScoreData[index]["email_audit_id"];
            this.manualScoreData[index]["manual_score"] = parseInt(event.target.value);
            this.metricsMatches[index]["manual_score"] = parseInt(event.target.value);
        }else{
            this.metricsMScore_valid  = true;
            this.metricsMScore_valid_text = "Entered value is not equal to Configured QA Score Or Zero";
            setTimeout(()=>{
              this.restrictScore.nativeElement.value="";
              this.metricsMScore = null;
              this.metricsMScore_valid  = false;
            },1000); 
        }
      } else {
        this.manualScoreData[index]["email_audit_id"] =  this.manualScoreData[index]["email_audit_id"];
        this.manualScoreData[index]["manual_score_comments"] = event.target.value;
        this.metricsMatches[index]["manual_score_comments"] = event.target.value;
    }
  }
 }


 changeNewLine(answer:any){
  if(answer){
    return answer.replace(/\n\r?/g, '<br />');
  }else{
    return answer;
  }
  
}

 selectTableData(value:any){
  this.page=1;
 // this.selectedSearchOption = this.columnSelect.nativeElement.value;
     if(this.selectedSearchOption){
      let selectedColumn =  this.filterColumnList.filter((column:any)=>column['value']==this.selectedSearchOption);
     if(selectedColumn.length > 0){
      if(selectedColumn[0]['condition'].length > 0){
        const res = selectedColumn[0]['condition'].map((obj:any) => {   
          obj = this.filterConditionList.find((obj2:any) => obj2.id === obj);
           return obj;
        });
        this.filterCondition=res.length > 0 ? res : [];
        if(value=='column'){
          this.selectedCondition = this.filterCondition[0]['value'];
        }
      }
      }else{
        this.filterCondition=[];
      }
 
     }
  this.tableSearch="";
  if(value==""){
    this.emailPayload = {
      'page':this.page,
      'per_page':this.limit,
      'filters': [{"property":"status","operator":"eq","value":"Completed"}]
    }
  }else{

    this.emailPayload = {
      page:this.page,
      limit: this.limit,
      'filters': []
    }
 }
   setTimeout(()=>{
     this.getEmailDataFun();
   },1000)
   
 }

 getDateSearchData(event: any) {
    this.getDateData = event;
  //  const startDate = this.datePipe.transform(this.getDateData?.startDate?.$d, 'yyyy-MM-dd');
    const startDate = this.datePipe.transform(this.dateRange || '', 'yyyy-MM-dd');
    console.log(startDate);
    if(startDate !=null){
     // this.filterDisable = false;
    }
     this.emailPayload = {
      page: 1,
      limit: this.limit,
      'filters': [{ 
         "property":this.selectedSearchOption,
         "operator":this.selectedCondition,
         "value":startDate
       }],
      
    };
    this.getEmailDataFun();
   
 }

 sendMailCustomer(){
      this.submitemail = true;
       this.mailSendForm.markAllAsTouched();
       this.mailSendForm.markAsDirty();
    if(this.mailSendForm.valid){
      this.mailSendForm.value["files"]=this.selectedFiles;
     // this.mailSendForm.value['body'] = this.mailSendForm.value['body']+"<b>Customer Mail<b><br/>"+this.sentimentData?.customer_mail;
       this.emailService.sendMailReply(this.mailSendForm.value).subscribe({next:(res:any)=>{
            if(res.hasOwnProperty("message")){
              this.notifier.notify("default",res['message']);
            }
      },error:(errors:HttpErrorResponse)=>{
          this.notifier.notify("default",errors['error']['error']);
      }});
    }else{
      this.notifier.notify("default","Fill Mandatory Fields");
    }
 }


 onFileChange(event:any){
  const file = event.target.files[0];
  const reader = new FileReader();
  reader.readAsDataURL(event);
  reader.onload = () => {
      console.log(reader.result);
  };
 }


 public toFilesBase64(files: File[], selectedFiles: any[]): Observable<any[]> {
  const result = new AsyncSubject<any[]>();
  if (files?.length) {
    Object.keys(files)?.forEach(async (file, i) => {
      const reader = new FileReader();
      reader.readAsDataURL(files[i]);
      reader.onload = (e) => {
        selectedFiles = selectedFiles?.filter(f => f?.name != files[i]?.name);
       // selectedFiles.push({ name: files[i]?.name, file: files[i], base64: reader?.result as string });
       selectedFiles.push({ file_name: files[i]?.name, file:reader?.result as string })
        result.next(selectedFiles);
        if (files?.length === (i + 1)) {
          result.complete();
        }
      };
    });
    return result;
  } else {
    result.next([]);
    result.complete();
    return result;
  }
}

public onFileSelected(event:any) {
  // this.selectedFiles = []; // clear
  const files = event.target.files
  this.toFilesBase64(files, this.selectedFiles).subscribe((res: any) => {
    this.selectedFiles = res;
    console.log("this.selectedFiles",this.selectedFiles);
  });
}

clearFile(event:any){
 return event.target.value = null;
}

refreshData(){
  this.tableSearch="";
  this.dateRange="";
  // this.columnSelect.nativeElement.value="";
  // this.conditionSelect.nativeElement.value="";
  this.selectedSearchOption="";
  this.selectedCondition="";
  //this.pickerDirective.clear();
      this.page=1;
      this.emailPayload['per_page'] = 25;
       this.emailPayload['filters']= [{"property":"status","operator":"eq","value":"Completed"}];
     
 
  this.getEmailDataFun();
}  
}
